
import { IoManOutline } from "react-icons/io5";
import { IoWomanOutline } from "react-icons/io5";


import './../styles/registrationtwo.css'
import { OFFICE_ROUTE} from '../utils/consts';

import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { GiWeightScale } from "react-icons/gi";
import { GiMuscularTorso } from "react-icons/gi";
import { GiRunningShoe } from "react-icons/gi";



import FooterLogin from '../components/footer_login/footer_login';
import HeaderLogin from '../components/header_login/header_login';
import logo_google from './../img/logo/google.png';
import defimage from './../img/photo/def.jpg';
import { NavLink } from 'react-router-dom';
import { MdPhotoCamera } from "react-icons/md";

import React, { useState } from 'react';

import AnchorLink from '../components/AnchorLink';
import './../styles/registration.css'
import { LOGIN_ROUTE } from '../utils/consts';


const Card = ({ title, initialValue }) => {
    const [value, setValue] = useState(initialValue);
  
    return (
      <div className="card">
        <div className="title">{title}</div>
        <div className="value">{value}</div>
        <div className="controls">
          <button className='btn-plus' onClick={() => setValue(value - 1)}>-</button>
          <button className='btn-minus' onClick={() => setValue(value + 1)}>+</button>
        </div>
      </div>
    );
};

const Card2 = ({ text, selected, onSelect, icon }) => (
    <div className={`card2 ${selected ? 'selected' : ''}`} onClick={onSelect}>
      <div className="card-icon">{icon}</div>
      <h3>{text}</h3>
      {selected && <div className="checkmark"><IoIosCheckmarkCircleOutline /></div>}
    </div>
  );




const Registration = () => {

    const [step, setStep] = useState(1);

    const showNextStep = () => {
        setStep(prevStep => prevStep + 1);
    };
    
    const showPreviousStep = () => {
        setStep(prevStep => prevStep - 1);
    };


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [nameError, setNameError] = useState(false);
    // const navigate = useNavigate();

    const handleLogin = () => {
        setEmailError(email === '');
        setPasswordError(password === '');
        setNameError(name === '');

        if(email !== '' && password !== '' && name !== '') {
            showNextStep();
        }
    }


    const [image, setImage] = useState('');

    const handleImageChange = (e) => {
        setImage(URL.createObjectURL(e.target.files[0]));
    }



    const [isChecked, setIsChecked] = useState(false);

    const [active, setActive] = useState('man');

    const [selectedCard, setSelectedCard] = useState(null);
    const cards = [
        { text: 'Спалити жир', icon: <GiWeightScale /> },
        { text: 'Набір м\'язів', icon: <GiMuscularTorso /> },
        { text: 'Підтримка форми', icon: <GiRunningShoe /> },
      ];

    return ( 
        <>
        <HeaderLogin/>
        {step === 1 && (
        <div id="registerStepOne" className='login'>
            <div className="container_login">
                <div className="half">
                <div className='divstep'>
                <div className="step">
                    <div className='step_text1'>Створити акаунт</div>
                    <div className="circle1">1</div>
                </div>

                <div className="step">
                    <div className='step_text2'>Особисті дані</div>
                    <div className="circle2">2</div>
                </div>
                </div>
                </div>
                <div className="half">
                    <p className='plog1'>Створити свій обліковий запис</p>
                    <form className='forms'>
                        <div className={"input-container " + (emailError ? 'error' : '')}>
                            <input type="email" id="email" name="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            {emailError && <p className='error-message'>Треба заповнити пусте поле</p>}
                        </div>
                        <div className={"input-container " + (passwordError ? 'error' : '')}>
                            <input type="password" id="password" name="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)}/>
                            {passwordError && <p className='error-message'>Треба заповнити пусте поле</p>}
                        </div>
                        <div className="profile-container">
                            <img className="profile-image" src={image || defimage} alt="Profile" />
                            <label className="profile-image-label">
                                <input type="file" onChange={handleImageChange} style={{display: 'none'}} />
                                <span className="camera-icon"><MdPhotoCamera /></span>
                            </label>
                        </div>
                    </form>
                    <p className='plog2'>Ваше ім'я</p>
                    <div className={"input-container " + (nameError ? 'error' : '')}>
                        <input type="name" id="name" name="name" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)}/>
                        {nameError && <p className='error-message1'>Треба заповнити пусте поле</p>}
                    </div>
                    
                    <p className='plog2'>Або увійти за допомогою соціальних мереж</p>
                    <div className='btn_googl'>
                    <AnchorLink id="#!" className='google-btn'>
                      <img src={logo_google} alt="Google logo" className='google-img'/>
                      Google
                    </AnchorLink>
                    </div>

                    <div>
                        <div className='btns_log1'>
                            {/* <NavLink to={REGISTRATIONTWO_ROUTE}> */}
                                <div className='next2' onClick={handleLogin}>
                                   <p className='t_enter'>ПРОДОВЖИТИ</p>
                                </div>
                            {/* </NavLink> */}
                            <NavLink to={LOGIN_ROUTE} className='l_registration'>
                                <div className='back'>
                                    <p className='t_registration'>ВІДМІНА</p>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )}



        {step === 2 && (
        <div id="registerStepTwo" className='registrationtwo'>
            <div className="container_registrationtwo">
                <div className="half">
                <div className='divstep2'>
                <div className="step2">
                    <div className='step_text12'>Створити акаунт</div>
                    <div className="circle12">1</div>
                </div>

                <div className="step2">
                    <div className='step_text22'>Особисті дані</div>
                    <div className="circle22">2</div>
                </div>
                </div>
                </div>
                <div className="half">
                    <p className='plog1'>Особисті дані</p>

                    <div className="switch">
                        <div className={`option ${active === 'man' ? 'active' : ''}`} onClick={() => setActive('man')}>
                            <div className="icon"><IoManOutline /></div>
                            <div className='t_switch'>Чоловік</div>
                        </div>
                        <div className={`option ${active === 'woman' ? 'active' : ''}`} onClick={() => setActive('woman')}>
                             <div className="icon"><IoWomanOutline /></div>
                            <div className='t_switch'>Жінка</div>
                        </div>
                    </div>

                    <div className='card-container'>
                        <Card title="Biк" initialValue={24} />
                        <Card title="Baгa" initialValue={82} />
                        <Card title="Зріст" initialValue={178} />
                    </div>


                    <div>
                        <p className='plog2'>Яка ваша мета:</p>
                    </div>

                    
                    <div className="card-container2">
                        {cards.map((card, index) => (
                            <Card2
                              key={index}
                              text={card.text}
                              icon={card.icon}
                              selected={selectedCard === index}
                              onSelect={() => setSelectedCard(index)}
                            />
                        ))}
                    </div>

                    <div>
                    <form className='checkbox'>
                    <input 
                        type="checkbox" 
                        id="remember-me" 
                        name="remember-me" 
                        className='check_box' 
                        onChange={() => setIsChecked(!isChecked)}
                    />
                    <label htmlFor="remember-me" className='remember-me'>
                        Я прочитав(ла) Правила користування та даю згоду на обробку особистих даних
                    </label>
                    </form>
                        <div className='btns_log'>
                            <NavLink to={OFFICE_ROUTE} className={isChecked ? 'active' : 'disabled'}>
                               <div className='next'>
                                   <p className='t_enter'>РЕЄСТРАЦІЯ</p>
                                </div>
                            </NavLink>
                            {/* <NavLink to={REGISTRATION_ROUTE} className='l_registration'> */}
                                <div className='back' onClick={showPreviousStep}>
                                    <p className='t_registration'>ПОВЕРНУТИСЯ</p>
                                </div>
                            {/* </NavLink> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )}







        <FooterLogin/>
        </>
     );
}
 
export default Registration;